import { useState } from 'preact/hooks'

export default function initializeForm({ initialValues, formSchema }) {
  const [formValues, setFormValues] = useState({ ...initialValues })
  const [formErrors, setFormErrors] = useState(null)

  function validateForm() {
    return new Promise((resolve, reject) => {
      setFormErrors(null)
      formSchema
        .validate(formValues, { abortEarly: false })
        .then(validFormData => {
          resolve(validFormData)
        })
        .catch(err => {
          const errors = err.inner.reduce(
            (obj, error) => ({
              ...obj,
              [error.path]: error.message,
            }),
            {},
          )
          setFormErrors({ ...errors })
          reject()
        })
    })
  }

  function handleInputChange(key, value) {
    setFormValues({
      ...formValues,
      [key]: value,
    })
    if (formErrors && formErrors[key]) {
      setFormErrors({
        ...formErrors,
        [key]: null,
      })
    }
  }

  return {
    formValues,
    formErrors,
    handleInputChange,
    validateForm,
    resetForm: () => setFormValues({ ...initialValues }),
  }
}
